import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreAirPriceWatchComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { LoadingScreen } from "@hsbc/portal";
import styles from "./styles.module.scss";

export interface WatchLoadingScreenProps {
  isLoading: boolean;
}
export const WatchLoadingScreen = ({
  isLoading = false,
}: WatchLoadingScreenProps) => {
  const [block, _] = useModuleBEM(
    styles,
    CoreAirPriceWatchComponent.WatchListLoadingScreen
  );

  const { t } = useI18nContext();

  return (
    <div className={block} id="watch-loading">
      <LoadingScreen
        isLoading={isLoading}
        loadingSteps={[{ title: t("fetchingWatches") }]}
      />
    </div>
  );
};
